import PrefixEnum from '../prefixes'

export default Object.freeze({
    'www.crossandshape.de': PrefixEnum.ADRIENNE,
    'crossandshape.de': PrefixEnum.ADRIENNE,
})
